import React from 'react';
import FeatureCard from './FeatureCard';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'Palette',
      title: 'Multimedia Learning Trails',
      description: 'Create engaging educational content with images, videos, interactive games, and quizzes. Our creative studio provides all the tools you need to design immersive learning experiences.',
      color: 'primary',
    },
    {
      icon: 'QrCode',
      title: 'QR Code Generation',
      description: 'Generate printable QR codes linked to your learning trails. Place them anywhere in your school to create physical learning trails that students can scan and explore.',
      color: 'accent',
    },
    {
      icon: 'BarChart3',
      title: 'Student Progress Analytics',
      description: 'Track student engagement and completion rates with comprehensive analytics. Monitor who has attempted and completed each learning trail to measure educational impact.',
      color: 'success',
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6">
            Everything You Need to Transform Learning
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Powerful features designed specifically for educators to create, manage, and track interactive learning experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <div key={index} className={`stagger-fade-in stagger-delay-${index + 1}`}>
              <FeatureCard {...feature} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;